import React from 'react'
import Navbar from '../component/Navbar'
import Hero from '../component/Hero'
import Services from '../component/Services'
import About from '../component/About'
import Contact from '../component/Contact'
import Footer from '../component/Footer'
import FloatingButtons from '../component/FloatingButtons'
const Home = () => {
  return (
    <div>
        <Navbar/>
     <Hero/>
     <Services/>
     <About/>
     <Contact/>
     <Footer/>
     <FloatingButtons/>
    </div>
  )
}

export default Home
